import React, { useCallback, useState } from "react";
import { baseUrl, logoutApiUrl } from "../helpers/Config";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutApiAction, postLog } from "../services/api";
import { useShowManualData } from "../helpers/SwitchTab_Context";
import { clearAll } from "../helpers/localStorage";

// Constants
export const LOGOUT_SUCCESS_MESSAGE =
  "All other sessions have been logged out. You can now login again.";
export const LOGOUT_SAVE_LOG = "Logout Operation Successfull";

const Common_Logout = () => {
  const token = localStorage.getItem("nic_front_authToken");
  const userId = localStorage.getItem("nic_front_userId");
  const [logoutLoading, setLogoutLoading] = useState(false);
  const { parichayLogout } = useShowManualData();
  const dispatch = useDispatch();
  const logoutMessage = useSelector(
    (state) => state?.logoutData?.data?.message
  );
  const navigate = useNavigate();

  // Logout function
  const logout = async () => {
    try {
      if (userId) {
        setLogoutLoading(true);
        const response = await dispatch(
          postLog({ userId, token, action: "Logout" })
        );
        console.log("response is", response?.payload?.message);
        if (response?.payload?.message === LOGOUT_SAVE_LOG) {
          console.log("reached in removetoken");
          reomveToken();
        }
      }
    } catch (error) {
      console.error("Error during postLog:", error);
    }
  };

  // Remove token
  const reomveToken = useCallback(async () => {
    if (token && userId && logoutMessage !== LOGOUT_SUCCESS_MESSAGE) {
      const apiUrl = `${baseUrl}${logoutApiUrl}`;
      const requestPayload = { user_id: userId };

      try {
        const response = await dispatch(
          logoutApiAction({ apiUrl, field: requestPayload, token })
        );
        if (response?.payload?.message === LOGOUT_SUCCESS_MESSAGE) {
          handleSuccessfulLogout();
        } else {
          console.error("Logout API failed:", response);
        }
      } catch (error) {
        console.error("Error during logoutApiAction:", error);
      }
    }
  }, [
    token,
    userId,
    logoutMessage,
    baseUrl,
    logoutApiUrl,
    parichayLogout,
    clearAll,
    navigate,
    dispatch,
  ]);

  // Handle successful logout
  const handleSuccessfulLogout = async () => {
    try {
      await parichayLogout();
      await clearAll(); // Clear localStorage
      const response = await dispatch({ type: "RESET" });
      console.log("Reset request", response);
      setLogoutLoading(false);
      navigate("/");
    } catch (error) {
      console.error("Error during successful logout handling:", error);
    }
  };

  return { logout, logoutLoading };
};

export default Common_Logout;
